import { createAction } from 'typesafe-actions'
import { AppliedFilter } from '../../../entities/Filter'
import { ModelFiltersState } from '../../reducers/modelFiltersReducer'

export const setModelFilter = createAction('DOC / ModelFilter / set filter')<AppliedFilter>()

export const setModelFiltersState = createAction('DOC / ModelFilter / set state')<ModelFiltersState>()

export const removeEntireModelFilter = createAction('DOC / ModelFilter / remove entire filter')<string>()

export const resetModelFiltersState = createAction('DOC / ModelFilter / reset state')()
